import React from 'react';
import Icon from '../../../components/AppIcon';

const SPEC_ICON_MAP = {
  size: 'Square',
  area: 'Square',
  dimensions: 'Square',
  layout: 'LayoutGrid',
  style: 'Palette',
  color: 'Palette',
  finish: 'Palette',
  material: 'Layers',
  countertop: 'Layers',
  appliance: 'Zap',
  electrical: 'Lightbulb',
  lighting: 'Lightbulb',
  plumbing: 'Droplets',
  water: 'Droplets',
  timeline: 'Clock',
  deadline: 'Calendar',
  budget: 'DollarSign',
  location: 'MapPin',
  default: 'FileText',
};

const getIconForKey = (key) => {
  const lower = key?.toLowerCase() || '';
  for (const [keyword, icon] of Object.entries(SPEC_ICON_MAP)) {
    if (lower?.includes(keyword)) return icon;
  }
  return SPEC_ICON_MAP?.default;
};

const formatLabel = (key) =>
  key
    ?.replace(/([A-Z])/g, ' $1')
    ?.replace(/_/g, ' ')
    ?.replace(/\b\w/g, (c) => c?.toUpperCase())
    ?.trim() || key;

const formatValue = (value) => {
  if (value === null || value === undefined) return 'Not specified';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (Array.isArray(value)) return value?.join(', ') || 'Not specified';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

const ProjectSpecifications = ({ specifications }) => {
  const entries = specifications && typeof specifications === 'object'
    ? Object.entries(specifications)?.filter(
        ([, v]) => v !== null && v !== undefined && String(v)?.trim() !== ''
      )
    : [];

  if (entries?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-8 text-center">
        <Icon name="FileText" size={40} className="mx-auto text-text-secondary mb-3" />
        <h3 className="text-lg font-semibold text-foreground mb-2">No Specifications Available</h3>
        <p className="text-text-secondary text-sm">
          The buyer has not added detailed specifications for this project yet.
        </p>
      </div>
    );
  }

  // Group entries into pairs for a 2-column grid layout
  const chunks = [];
  for (let i = 0; i < entries?.length; i += 3) {
    chunks?.push(entries?.slice(i, i + 3));
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {entries?.map(([key, value]) => (
          <div key={key} className="bg-card border border-border rounded-xl p-6">
            <div className="flex items-center space-x-2 mb-4">
              <Icon name={getIconForKey(key)} size={20} className="text-primary" />
              <h3 className="text-base font-semibold text-foreground">{formatLabel(key)}</h3>
            </div>
            <p className="text-sm text-text-secondary leading-relaxed">{formatValue(value)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectSpecifications;